"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const format_currency_1 = require("@App/helpers/format-currency");
const uuid_1 = require("uuid");
const mobx_react_1 = require("mobx-react");
require("../index.scss");
const StatementsTable = (props) => {
    const { selectAll, deselectAll, data, checkedItems, addItemToDownloadData, removeItemFromDownloadData } = props;
    const itemsChecked = !!checkedItems.length;
    const handleSelectAll = () => {
        if (!itemsChecked && selectAll) {
            selectAll();
        }
        else if (itemsChecked && deselectAll) {
            deselectAll();
        }
    };
    const handleCheck = (checked, uuid) => {
        if (checked && addItemToDownloadData) {
            addItemToDownloadData(uuid);
        }
        else if (!checked && removeItemFromDownloadData) {
            removeItemFromDownloadData(uuid);
        }
    };
    return (react_1.default.createElement("div", { className: "royalties-table" },
        react_1.default.createElement("table", null,
            react_1.default.createElement("tbody", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", { className: "index-white" }, "Payee"),
                    react_1.default.createElement("th", { className: "index-white" }, "DSP"),
                    react_1.default.createElement("th", { className: "index-white" }, "Distribution Period"),
                    react_1.default.createElement("th", { className: "index-white" }, "Amount"),
                    react_1.default.createElement("th", { className: "index-white", onClick: () => handleSelectAll() }, itemsChecked ? 'Deselect All' : 'Select All')),
                data.length > 0 &&
                    data.map((row) => (react_1.default.createElement("tr", { key: (0, uuid_1.v4)() },
                        react_1.default.createElement("td", null, row.payee),
                        react_1.default.createElement("td", null, row.dsp),
                        react_1.default.createElement("td", null, Intl.DateTimeFormat('en', { month: 'long', year: 'numeric' }).format(new Date(row.year, row.month - 1))),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement("div", { className: 'currency' },
                                react_1.default.createElement("p", null, (0, format_currency_1.formatUSD)(row.amount)))),
                        react_1.default.createElement("td", null,
                            react_1.default.createElement("div", { className: 'select' },
                                react_1.default.createElement("input", { type: 'checkbox', defaultChecked: checkedItems.includes(row.id), onChange: (event) => handleCheck(event.target.checked, row.id) })))))),
                data.length === 0 && (react_1.default.createElement("tr", { key: (0, uuid_1.v4)() },
                    react_1.default.createElement("td", { colSpan: 5 }, "No statement is available as no usage activity was reported for this time period. Please note that it takes about three payment cycles for newly submitted works data to make an impact on your statements.")))))));
};
exports.default = (0, mobx_react_1.observer)(StatementsTable);
